import create from 'zustand';
import axios from 'http/request';
import orderBy from 'lodash/orderBy';
import { getValueFromStorage } from 'http/request';

const getCurrentAnswer = (answer, isFileUpload) => {
  const newAnswer = {};
  const uid = answer.get('Uid');
  const answerText = answer.get('AnswerText');
  const file = answer.get('file');
  const description = answer.get('description');
  newAnswer.uid = uid;
  if (description) {
    newAnswer.description = description;
  }
  if (file) {
    newAnswer.answer = file;
  } else {
    newAnswer.answer = answerText;
  }
  return newAnswer;
};

const useJournalStore = create((set, get) => ({
  surveys: [],
  surveyQuestions: [],
  surveyAnswers: [],
  error: null,
  surveyLength: 0,
  completedSurvey: [],
  doGetFilteredSurvey: async (status) => {
    try {
      set({
        error: null,
      });
      const resp = await axios.get(`/survey/get-surveys?Statuses=${status}`);
      const { data } = resp;
      if (status === 3) {
        set({
          completedSurvey: data,
        });
      } else {
        set({
          surveys: data,
          surveyLength: data?.length,
        });
      }
    } catch ({ response }) {
      set({
        error: response?.data.title,
      });
    }
  },
  doGetSurveyQuestions: async (surveyResponseId) => {
    try {
      set({
        error: null,
        loadingQuestions: true,
      });
      const resp = await axios.get(`/survey/get-survey-questions?SurveyResponseId=${surveyResponseId}`);
      const { data: questions } = resp;
      // TODO: we need to identify the proper sorting logic, currently decided to show in the same order getting from BE
      // const questions = orderBy(data, ['questionTypeId', 'displayOrder']);
      set({
        surveyQuestions: questions,
        loadingQuestions: false,
      });
    } catch ({ response }) {
      set({
        error: response?.data.title,
      });
    }
  },
  updateAnswerByUID: async (answer, isFileUpload = false) => {
    const { surveyAnswers } = get();
    const newAnswer = getCurrentAnswer(answer, isFileUpload);
    try {
      set({
        error: null,
      });
      const resp = await axios.put('/survey/update-survey-answer', answer);
      if (resp.status === 200) {
        let updatedAnswer = [...surveyAnswers];
        const currentAnswer = surveyAnswers.find((ans) => ans.uid === answer.get('Uid'));
        if (!currentAnswer) {
          updatedAnswer.push(newAnswer);
        } else {
          const index = surveyAnswers.findIndex((ans) => ans.uid === answer.get('Uid'));
          updatedAnswer[index] = newAnswer;
        }
        set({
          surveyAnswers: updatedAnswer,
        });
        return true;
      }
    } catch ({ response }) {
      set({
        error: response?.data
          ? response.data.title
            ? response.data.title
            : response.data[0].text
          : response.data.message,
      });
      return false;
    }
  },
  updateSurveyStatus: async (surveyStatus) => {
    try {
      set({
        error: null,
      });
      await axios.put('/survey/update-survey-status', surveyStatus);
      return true;
    } catch ({ response }) {
      set({
        error: response?.data?.title ? response?.data?.title : response?.data[0].text,
      });
      return false;
    }
  },
  doGetSurveyAnswers: async (surveyResponseId) => {
    try {
      set({
        error: null,
        loadingAnswers: true,
      });
      const resp = await axios.get(`/survey/get-survey-question-answers?SurveyResponseId=${surveyResponseId}`);
      const { data: questions } = resp;
      // TODO: we need to identify the proper sorting logic, currently decided to show in the same order getting from BE
      // const questions = orderBy(data, ['displayOrder'], ['asc']);
      set({
        surveyAnswers: questions,
      });
      return true;
    } catch ({ response }) {
      set({
        error: response?.data?.title ? response?.data?.title : response?.data[0].text,
      });
      return false;
    } finally {
      set({ loadingAnswers: false });
    }
  },
  doSaveAndExit: async (surveyDetails) => {
    try {
      set({
        error: null,
      });
      const resp = await axios.put(`/survey/save-and-exit`, surveyDetails);
      return resp.status === 200;
    } catch ({ response }) {
      set({
        error: response?.data?.title ? response?.data?.title : response?.data[0].text,
      });
      return false;
    }
  },
  doResetError: () => set({ error: null }),
  doUpdateSurveys: (updatedSurvey) => {
    const { surveys } = get();
    const index = surveys.findIndex((survey) => survey.surveyResponseId === updatedSurvey.surveyResponseId);
    if (index > -1) {
      const updatedSurveys = [...surveys.slice(0, index), updatedSurvey, ...surveys.slice(index + 1)];
      set({
        surveys: updatedSurveys,
      });
    }
  },
  doExitSurvey: async (surveyResponseId) => {
    const { updateSurveyStatus } = get();
    try {
      set({
        error: null,
      });
      const resp = await axios.put(`/survey/clear-survey?SurveyResponseId=${surveyResponseId}`);
      const { status } = resp;
      if (status === 200) {
        set({
          surveyQuestions: [],
          surveyAnswers: [],
        });
        const newSurveyStatus = {
          surveyResponseId,
          statusId: 1,
        };
        const isStatusUpdated = updateSurveyStatus(newSurveyStatus);
        if (isStatusUpdated) return true;
        return false;
      }
    } catch ({ response: { data } }) {
      set({
        error: data,
      });
    }
  },
}));

export default useJournalStore;
